// extracted by mini-css-extract-plugin
module.exports = {"logoBackground":"CarouselStudioBranding_logoBackground__naeKq","logoBackgroundMobile":"CarouselStudioBranding_logoBackgroundMobile__EYdTK"};